// extracted by mini-css-extract-plugin
export var card = "trainingCard-module--card--011fd";
export var imgContainer = "trainingCard-module--imgContainer--fef27";
export var info = "trainingCard-module--info--f0dab";
export var readBtn = "trainingCard-module--readBtn--16d81";